/* eslint-disable */
export const logger = {
	log: console.log,
	warn: console.warn,
	error: console.error,
	groupCollapsed: console.groupCollapsed,
	group: console.group,
	groupEnd: console.groupEnd,
};
